export default __webpack_public_path__ + "static/media/marker-empty.c7c60974.png";